module.exports = __webpack_public_path__ + "img/fabrixapi-bg.c6301d17.svg";